import { Module } from 'vuex';

import { AuthState } from '../../models';

import { LoadStateFromStorageAction } from './actions/load-state-from-storage.action';
import { LoginAction } from './actions/login.action';
import { LogoutAction } from './actions/logout.action';
import { RefreshAction } from './actions/refresh.action';
import { SetTokenAction } from './actions/set-token.action';
import { AUTH_CONSTS } from './auth.consts';
import { IsLoggedInGetter } from './getters/is-logged-in.getter';
import { KeepLoggedInGetter } from './getters/keep-logged-in.getter';
import { TokenInfoGetter } from './getters/token-info.getter';
import { TokenGetter } from './getters/token.getter';
import { ClearModuleMutation } from './mutations/clear-module.mutation';
import { SetStateMutation } from './mutations/set-state.mutation';

export const AUTH_MODULE: Module<AuthState, any> = {
  namespaced: true,

  state: (): AuthState => {
    return {
      token: undefined,
      refreshToken: undefined,
      keepLoggedIn: false
    };
  },

  getters: {
    [AUTH_CONSTS.getters.token]: TokenGetter.execute,
    [AUTH_CONSTS.getters.tokenInfo]: TokenInfoGetter.execute,
    [AUTH_CONSTS.getters.isLoggedIn]: IsLoggedInGetter.execute,
    [AUTH_CONSTS.getters.keepLoggedIn]: KeepLoggedInGetter.execute
  },

  actions: {
    [AUTH_CONSTS.actions.loadStateFromStorage]: LoadStateFromStorageAction.execute,
    [AUTH_CONSTS.actions.login]: LoginAction.execute,
    [AUTH_CONSTS.actions.logout]: LogoutAction.execute,
    [AUTH_CONSTS.actions.refresh]: RefreshAction.execute,
    [AUTH_CONSTS.actions.setToken]: SetTokenAction.execute
  },

  mutations: {
    [AUTH_CONSTS.mutations.setState]: SetStateMutation.execute,
    [AUTH_CONSTS.mutations.clearModule]: ClearModuleMutation.execute
  }

};
